import _ from "lodash";
import React, { useState } from "react";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import { api } from "../utils";

export default function TestItemTypeahead(props) {
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  const groupStyle = {
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 'bold',
    margin: '2px 0 0 0'
  };

  const groupLabelFormat = data => (
    <div style={groupStyle}>
      <span>{data.label}</span>
    </div>
  );

  const groupOptions = (list) => {
    const [sampleItems, productionItems] = _.partition(list, x => x.isSample);
    let result = [];
    if (productionItems.length) {
      result.push({
        label: "***** Production Items *****",
        options: productionItems
      });
    }
    if (sampleItems.length) {
      result.push({
        label: "***** Sample Items *****",
        options: sampleItems
      });
    }
    return result;
  };

  const loadItemOptions = (typedValue, callback) => {
    if (!typedValue || !typedValue.length || typedValue.length < 2) return;
    setLoading(true);
    let payload = { searchString: typedValue };
    api
      .post("Item/TestItemTypeahead", payload)
      .then((response) => {
        let list = _.map(response.data, (d) => {
          d.label = d.itemWithDesc;
          d.value = d.itemNumber;
          // need all the values for other
          return d;
        });
        if (props.includeSampleItems) {
          callback(groupOptions(list));
        } else {
          callback(list);
        }
      })
      .catch(() => {
        toast.error("There was an error loading item information.");
        callback([]);
      })
      .finally(() => setLoading(false));
  }

  return (
    <AsyncSelect
      id={props.id || ""}
      classNamePrefix='serviceThreadSelect'
      loadOptions={loadItemOptions}
      onInputChange={(e) => setInputValue(e)}
      onChange={props.onChange}
      formatGroupLabel={groupLabelFormat}
      inputValue={inputValue}
      value={props.value}
      onFocus={props.onFocus}
      placeholder={props.placeholder || "Type the item number you are looking for"}
      noOptionsMessage={() => "Start typing to search Items"}
      isLoading={loading}
      isDisabled={props.disabled}
      isClearable
    />
  );
} 